export default __webpack_public_path__ + "stumbler-fifth.7b91cdc1.mp4";